module.exports = __webpack_public_path__ + "img/lost.a851c96d.png";